import * as OrderTexts from '../../../../../../../../intl'
import {
  MAX_CUSTOM_FIELD_NAME_LENGTH,
  MAX_CUSTOM_FIELD_VALUE_LENGTH,
} from '../components/CustomFieldList/components/CustomFieldInput/constants'

type CustomFieldsErrors = Record<string, { name?: string; value?: string }>

interface CustomFieldsValidationResult {
  errors: CustomFieldsErrors
  totalLength: number
  hasValueTooLong: boolean
}

export function getCustomFieldsValidationErrors(
  customFields: Record<string, string>,
  allowEmptyCustomFields: boolean,
): CustomFieldsValidationResult {
  let totalLength = 0
  let hasValueTooLong = false
  const errors = Object.entries(customFields).reduce<CustomFieldsErrors>((acc, [key, value]) => {
    const trimmedLength = value?.trim().length || 0
    totalLength += trimmedLength
    // The name is always required; the admin config only relaxes the value requirement.
    const isEmptyKey = key.trim() === ''
    const isNameTooLong = key.length > MAX_CUSTOM_FIELD_NAME_LENGTH
    const isEmptyValue = !allowEmptyCustomFields && trimmedLength === 0
    const isValueTooLong = (value?.length || 0) > MAX_CUSTOM_FIELD_VALUE_LENGTH

    if (isValueTooLong) {
      hasValueTooLong = true
    }

    if (isEmptyKey || isNameTooLong || isEmptyValue) {
      acc[key] = {
        name: isEmptyKey
          ? OrderTexts.getValidationErrorCustomFieldName()
          : isNameTooLong
            ? OrderTexts.getValidationErrorMaxLengthText(MAX_CUSTOM_FIELD_NAME_LENGTH)
            : undefined,
        value: isEmptyValue ? OrderTexts.getValidationErrorCustomFieldText() : undefined,
      }
    }

    return acc
  }, {})

  return { errors, totalLength, hasValueTooLong }
}
